import { resolveImageUrl } from './image';

export const getPreferredImageUrl = (
  originalUrl: string,
  mediumUrl?: string,
  preference?: 'original' | 'medium'
): string => {
  // Default to medium if preference is undefined or explicitly set to medium
  if ((!preference || preference === 'medium') && mediumUrl) {
    return resolveImageUrl(mediumUrl);
  }
  return resolveImageUrl(originalUrl);
};
